import React from "react";
import "./Prize.css";
import {isMobile} from "react-device-detect";
import {arrow_line, moneybag} from "./images";


const Prize = (props) => {


    return (
        <div style={{zIndex: 10, display: "flex", justifyContent: "center", flexDirection: 'column', marginTop: 20, paddingBottom: 100}}>
            <div style={isMobile ? {flexDirection: "column"} : {flexDirection: "row", alignItems: "end"}} className={"prize-block"}>
                    <div style={{padding: 20}}>
                        <p className={'prize-title-text'}>Prize</p>
                        <p className={'prize-text'}>The top 50 traders from both TradeX and PRDT Finance (collectively) will share the 1000 USDT reward pool, with rewards distributed based on their leaderboard ranking.</p>
                        <div className={"prize-line"}/>
                        <p className={'prize-text'}>TradeX Signup Bonus: New users on TradeX will receive 2500 token points upon signup, which they can use to trade on the platform during the contest period.</p>
                    </div>
                <img src={moneybag()} height={150} style={isMobile ? {width: 250, height: 200, zIndex: 10, alignSelf: "end", borderRadius: 15} : { zIndex: 10, borderRadius: 15}}></img>
            </div>
        </div>
    );
};



export default (Prize);
